import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { hosts } from "@songtradr-sso/shared/common";
import { env } from "@songtradr-sso/shared/frontend";
import { App } from "./app/App";

Sentry.init({
  dsn: "https://ada0881b3c23fa0713819eea720bc691@o363271.ingest.us.sentry.io/4510831810707457",
  environment: hosts.environment,
  initialScope: {
    tags: { node_env: env.nodeEnv, deploy_alias: env.deployAlias },
  },
  enabled: env.nodeEnv === "production",
  sendDefaultPii: false,
});

const root = createRoot(document.getElementById("root") as HTMLElement, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
